import { render, staticRenderFns } from "./HouseSavor.vue?vue&type=template&id=1826e021&scoped=true"
import script from "./HouseSavor.vue?vue&type=script&lang=js"
export * from "./HouseSavor.vue?vue&type=script&lang=js"
import style0 from "./HouseSavor.vue?vue&type=style&index=0&id=1826e021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1826e021",
  null
  
)

export default component.exports